import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.22 3.98a.75.75 0 0 1 .53-1.28h.75A1.5 1.5 0 0 1 17 4.2v12a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 2 16.2V8.45a.75.75 0 0 1 1.5 0v7.75h12v-12h-.75a.75.75 0 0 1-.53-.22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.045 13.237a.58.58 0 0 1-.171-.412V9.158a.583.583 0 0 1 .583-.583h3.667a.583.583 0 0 1 0 1.166H8.866l3.588 3.587a.584.584 0 0 1-.826.826l-3.587-3.587v2.258a.583.583 0 0 1-.996.412"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.7 4.7A1.7 1.7 0 0 1 11 6.4H2A1.7 1.7 0 0 1 .3 4.7v-3A1.7 1.7 0 0 1 2 0h9a1.7 1.7 0 0 1 1.7 1.7zM11 5a.3.3 0 0 0 .3-.3v-3a.3.3 0 0 0-.3-.3H2a.3.3 0 0 0-.3.3v3A.3.3 0 0 0 2 5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }